// extracted by mini-css-extract-plugin
export default {"future_orders_items":"Vw","future_orders_item":"Ww","processing_order":"Xw","processing_order_wrapper":"Yw","order-history-future-orders":"Zw"};
    if(module.hot) {
      // 1726593103592
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  